import request from "@/lib/util/request";
import {SearchTypeInterface} from "@/lib/type/search.type";

// 获取热门搜索
export const requestGetHotSearch = () => request<SearchTypeInterface>({
    endpoint: "/api/tiny-shop/v1/index/hot-search",
    method: "GET",
    cache: "no-store"
})
